import { createSlice } from '@reduxjs/toolkit'

export const casinoHomeSlice = createSlice({
  name: 'casinoHome',
  initialState: {
    providersOnHome: {
      data: null,
      isLoading: false,
      error: null,
    },
    providerWiseData: {
      data: {}, // Object to store data for multiple providers by their IDs
      isLoading: false,
      error: null,
    },
  },
  reducers: {
    setProvidersOnHome: (state, action) => {
      state.providersOnHome = action.payload
    },
    setProviderWiseData: (state, action) => {
      const { providerId, name, data } = action.payload
      state.providerWiseData.data[name] = {
        providerId: providerId,
        data: data,
      }
    },
  },
})

export const { setProvidersOnHome, setProviderWiseData } =
  casinoHomeSlice.actions

export default casinoHomeSlice.reducer
